var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCareerChange(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5003 16.9004H9.49027C9.09815 16.9004 8.78027 17.2183 8.78027 17.6104V20.8104C8.78027 21.2025 9.09815 21.5204 9.49027 21.5204H14.5003C14.8924 21.5204 15.2103 21.2025 15.2103 20.8104V17.6104C15.2103 17.2183 14.8924 16.9004 14.5003 16.9004Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.29 19.2002H12.71",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.96 16.9002V15.4902H13.04V16.9002",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5805 14.09V12.93C10.5805 11.89 9.74047 11.06 8.71047 11.06V11.94L4.73047 9.65L8.71047 7.35V8.24C9.38047 8.24 10.0105 8.38 10.5805 8.63V6.48H9.69047L11.9905 2.5L14.2905 6.48H13.4005V8.63C13.9705 8.38 14.6005 8.24 15.2705 8.24V7.35L19.2505 9.65L15.2705 11.94V11.06C14.2405 11.06 13.4005 11.89 13.4005 12.93V14.09",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCareerChange);
export default __webpack_public_path__ + "static/media/Career Change.9875980f3efd275a701b16c77bcbc6a3.svg";
export { ForwardRef as ReactComponent };